module.exports = {
    DCGSupportUrl: "https://support.datecodegenie.com/"
}